<HiddenFromSSR>
  <footer>
    {@html "<p> Pinafore is <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/nolanlawson/pinafore\">open-source software</a> created by <a rel=\"noopener\" target=\"_blank\" href=\"https://nolanlawson.com\">Nolan Lawson</a> and distributed under the <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/nolanlawson/pinafore/blob/master/LICENSE\">AGPL License</a>. Here is the <a href=\"/settings/about#privacy-policy\" rel=\"prefetch\">privacy policy</a>. </p>"}
  </footer>
</HiddenFromSSR>
<script>
  import HiddenFromSSR from './HiddenFromSSR.html'

  export default {
    components: {
      HiddenFromSSR
    }
  }
</script>
